import { Popover as PopoverRoot, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover'
import { withIconSVG } from '../../patterns/icons/svg-tools/generator/withInlineSVG'
import InfoIconAsset from './info-icon.svg'
import { CompositeComponent, Empty } from 'lib'
import { getChildByType } from 'react-nanny'
import { popoverContent, popoverTrigger } from './Popover.css'
import { Typography } from 'ui/typography'

export const PopoverIcon = withIconSVG(InfoIconAsset)

export const Popover: CompositeComponent<Empty, 'Trigger' | 'Content'> = ({ children }) => {
	const trigger = getChildByType(children, [Popover.Trigger])
	const content = getChildByType(children, [Popover.Content])

	return (
		<PopoverRoot>
			{trigger}
			{content}
		</PopoverRoot>
	)
}

Popover.Trigger = ({ children }) => (
	<PopoverTrigger asChild className={popoverTrigger}>
		<Typography>{children}</Typography>
	</PopoverTrigger>
)
Popover.Content = ({ children }) => (
	<PopoverContent className={popoverContent} onOpenAutoFocus={e => e.preventDefault()}>
		{children}
	</PopoverContent>
)
